export const encode = (plaintext: string): string =>
  btoa(encodeURIComponent(plaintext))

export const decode = (encoded: string): string =>
  decodeURIComponent(atob(encoded))
